import { useEffect, useState } from "react";
import { useMap } from "maplibre-react-components";
import type { Map as MapLibreMap } from "maplibre-gl";

export const useIsDraggingMap = (mapId: string) => {
  const [isDragging, setIsDragging] = useState(false);
  const map = useMap(mapId) as MapLibreMap | null;
  useEffect(() => {
    if (!map) return;

    map.on("dragstart", () => setIsDragging(true));
    return () => {
      map.off("dragstart", () => setIsDragging(true));
      map.off("dragend", () => {
        setIsDragging(false);
      });
    };
  }, []);

  return isDragging;
};
